import React from 'react'
import classnames from 'classnames'
import selectFormat from '../selectFormat'

export default function EducationMetrics(props){

  let metrics = [
    {
      title: 'Graduation Rate Percentage',
      description: 'Percent of educational programs that were completed (have a graduation date after the admit date) for clients that were admitted at some point within the filter range.',
      format: 'number_horizontal_large',
      endpoint: 'graduation_rate_percentage',
      visible: true,
    },
    {
      title: 'Average GPA Upon Admit',
      description: 'Average GPA upon admit of all clients that were in the program at some point within the filter range.',
      format: 'number_horizontal',
      endpoint: 'average_gpa_upon_move_in',
      visible: true,
    },
    {
      title: 'Average GPA Upon Discharge',
      description: 'Average GPA upon discharge of all clients that were discharged at some point within the filter range.',
      format: 'number_horizontal',
      endpoint: 'average_gpa_upon_move_out',
      visible: true,
    },
    {
      title: 'Percent of Current Clients with Internship',
      description: 'Percent of clients that were admitted into the program at some point within the filter that have an internship that started after their admit date',
      format: 'number_horizontal_large',
      endpoint: 'percent_of_current_residents_with_internship',
      visible: true,
    },
    {
      title: 'Percent of Discharged Clients with Internship',
      description: 'Percent of clients that were discharged from the program at some point within the filter that have an internship that started after their admit date',
      format: 'number_horizontal_large',
      endpoint: 'percent_of_discharged_residents_with_internship',
      visible: true,
    },
  ]

  return(
    <div className="col-12 d-flex flex-wrap align-items-center h-100">
      {
        metrics.filter( metric => metric.visible == true ).map( (metric, index) => {
          return selectFormat(metric, index)
        })
      }
    </div>
  )
}